import { useState } from 'react';

const AccordionItem = ({ header, body, isOpen, onClick, isFirst }) => {
  return (
    <div className="accordion-item" >

      <div className={`accordion-item-header ${isOpen ? 'active' : ''}`} onClick={onClick} >
        <span>{header}</span>
        <span className='expander-button' >{`${isOpen ? '^' : 'v'}`}</span>
      </div>

      {isOpen && <div className='accordion-item-body'>{body}</div>}
    </div>
  )
}

const Accordion = ({ children }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleItemClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className='accordion'>
      {children.map((item, index) => (
        <AccordionItem
          isFirst={index === 0}
          key={index}
          header={item.header}
          body={item.body}
          isOpen={activeIndex === index}
          onClick={() => handleItemClick(index)}
        />
      ))}
    </div>
  )
};


export default Accordion;